import type {
	AnalyticsFunnels,
	AnalyticsMarketplaceStats,
	AnalyticsOrderStats,
	AnalyticsPeriodKey,
	AnalyticsSeries,
	AnalyticsSeriesMetric,
	AnalyticsUserStats,
	MediationView,
} from "@expertloop/shared";
import { adminApi } from "../../services/api";

/*
 * Appels de la vue d'ensemble.
 *
 * Toutes les valeurs affichées viennent de la fondation analytique : la page
 * ne calcule aucun montant et n'additionne rien elle-même. Les deux derniers
 * appels ne sont pas analytiques ; ils comptent ce qui attend un
 * administrateur, à partir des écrans qui existent déjà.
 */
export const overviewApi = {
	users: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsUserStats>(`/admin/analytics/users?period=${period}`),

	orders: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsOrderStats>(`/admin/analytics/orders?period=${period}`),

	marketplace: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsMarketplaceStats>(`/admin/analytics/marketplace?period=${period}`),

	series: (period: AnalyticsPeriodKey, metric: AnalyticsSeriesMetric) =>
		adminApi.get<AnalyticsSeries>(`/admin/analytics/series?period=${period}&metric=${metric}`),

	funnels: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsFunnels>(`/admin/analytics/funnels?period=${period}`),

	/** Les médiations à régler, les plus anciennes d'abord. */
	pendingMediations: (size: number) =>
		adminApi.get<{ mediations: MediationView[]; total: number }>(`/admin/mediations?page=1&pageSize=${size}`),

	reportStats: () =>
		adminApi.get<{ stats: { pending: number } }>("/admin/reports/stats"),
};
